import { render } from "./CompanyMaster.vue?vue&type=template&id=139852c2"
import script from "./CompanyMaster.vue?vue&type=script&lang=js"
export * from "./CompanyMaster.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__